var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"v-btn--app text--secondary text-capitalize font-weight-regular px-2"},'v-btn',Object.assign({}, {text: true},
    _vm.$attrs),false),_vm.$listeners),[(_vm.$slots.default)?_vm._t("default"):(_vm.path)?_c('i18n',{attrs:{"path":_vm.path}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }